import * as React from 'react';
import PropTypes from 'prop-types';
import { SortableContext } from '../SortableContainer';
import { provideDisplayName, omit } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  index: PropTypes.number.isRequired,
  collection: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool
};
const omittedProps = Object.keys(propTypes);
export default function sortableElement(WrappedComponent) {
  var _class;

  return _class = class WithSortableElement extends React.Component {
    constructor(...args) {
      super(...args);
      this.wrappedInstance = /*#__PURE__*/React.createRef();
    }

    componentDidMount() {
      this.register();
    }

    componentDidUpdate(prevProps) {
      if (this.node) {
        if (prevProps.index !== this.props.index) {
          this.node.sortableInfo.index = this.props.index;
        }

        if (prevProps.disabled !== this.props.disabled) {
          this.node.sortableInfo.disabled = this.props.disabled;
        }
      }

      if (prevProps.collection !== this.props.collection) {
        this.unregister(prevProps.collection);
        this.register();
      }
    }

    componentWillUnmount() {
      this.unregister();
    }

    register() {
      const {
        collection,
        disabled,
        index
      } = this.props;
      const node = this.wrappedInstance.current;
      node.sortableInfo = {
        collection,
        disabled,
        index,
        manager: this.context.manager
      };
      this.node = node;
      this.ref = {
        node
      };
      this.context.manager.add(collection, this.ref);
    }

    unregister(collection = this.props.collection) {
      this.context.manager.remove(collection, this.ref);
    }

    getWrappedInstance() {
      return this.wrappedInstance.current;
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, {
        ref: this.wrappedInstance,
        ...omit(this.props, omittedProps)
      });
    }

  }, _class.displayName = provideDisplayName('sortableElement', WrappedComponent), _class.contextType = SortableContext, _class.defaultProps = {
    collection: 0
  }, _class;
}